import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-project-detailed-section-gallery',
  templateUrl: './project-detailed-section-gallery.component.html',
  styleUrls: ['./project-detailed-section-gallery.component.css']
})
export class ProjectDetailedSectionGalleryComponent implements OnInit {

  @Input() projectImages: any;

  constructor() { }

  ngOnInit(): void {
  }

}
